<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">
  <form [formGroup]="filterGroup" ngProjectAs="filters" class="curve-filters">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Curve period</mat-label>
      <mat-select formControlName="datasetKey">
        <mat-option value="">{{ allPeriodLabel() }}</mat-option>
        @for (period of periods(); track period.datasetKey) {
          @if (period.periodKind === 'annual') {
            <mat-option [value]="period.datasetKey">{{ periodLabel(period) }}</mat-option>
          }
        }
      </mat-select>
    </mat-form-field>
    <p class="layer-note">{{ loading() ? 'Loading county curves…' : availableCount() + ' county curves available' }}</p>
    <button mat-stroked-button type="button" class="compare-button" [disabled]="loading() || curves().length === 0" (click)="openCompare()">
      Compare Curves ({{ curves().length }})
    </button>
  </form>

  <div class="legend" aria-label="Average power outage curve availability">
    <div class="legend-label"><span class="swatch available"></span><span>Curve available — click county</span></div>
    <div class="legend-label"><span class="swatch unavailable"></span><span>No curve for selected period</span></div>
  </div>
</tgrid-layer-header>
